import { Select as MantineSelect, SelectProps } from '@mantine/core';

import { FieldCaption } from '../FieldCaption';
import compactClasses from '../compactField.module.css';

import classes from './Select.module.css';

type Props = {
	caption?: string;
	/** Компактный вариант для десктопных фильтров и форм админки */
	compact?: boolean;
} & SelectProps;

export const Select = ({ caption, compact = false, ...rest }: Props) => {
	return (
		<MantineSelect
			classNames={compact ? compactClasses : classes}
			label={<FieldCaption compact={compact}>{caption}</FieldCaption>}
			{...(compact && { size: 'sm' })}
			{...rest}
		/>
	);
};
